import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../shared/config/colors';

const styles = makeStyles(({ breakpoints }) => {
  return {
    hyraulicsSubtitle: {
      marginBottom: '50px',
      [breakpoints.down(500)]: {
        fontSize: '30px',
        marginBottom: '30px'
      }
    },
    featuredWrapper: {
      position: 'relative',
      padding: '40px 0 0 0',
      maxWidth: '1450px',
      margin: '0 auto',
      textAlign: 'center',
      [breakpoints.down(500)]: {
        padding: '10px 0',
      }
    },
    featuredWrapperAccordion: {
      position: 'relative',
      padding: '40px 0 0 0',
      maxWidth: '1450px',
      margin: '0 auto',
      textAlign: 'center',
      [breakpoints.down(500)]: {
        padding: '10px 0',
      }
    },
    featuredWrapperRunParam: {
      position: 'relative',
      maxWidth: '1450px',
      margin: '0 auto',
      textAlign: 'center',
      paddingBottom: '40px',
      [breakpoints.down(500)]: {
        padding: '10px 0',
      }
    },
    featuredWrapperListParam: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      maxWidth: '1450px',
      margin: '0 auto',
      textAlign: 'center',
      [breakpoints.down(500)]: {
        padding: '10px 0',
      }
    },
    loading: {
      height: '300px',
      width: '100%',
      display: 'grid',
      placeItems: 'center'
    },
    accordianScrollUp: {
      position: 'fixed',
      bottom: 20,
      right: 20
    },
    chartTypesSelect: {
      padding: '20px',
      // paddingLeft: '40px',
      maxWidth: '2560px',
      width: '100%',
      position: 'relative',
      [breakpoints.down(500)]: {
        padding: '0px',
        paddingBottom: '10px',
        whiteSpace: 'nowrap',
        overflowX: 'auto',
        flexWrap: 'nowrap',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollMarginTop: '90px'
      }
    },
    active: {
      color: '#38b6FF',
      fontWeight: 'bold',
      textDecoration: 'underline',
      [breakpoints.down(500)]: {
        fontSize: '16px',
        padding: '0px',
        margin: '0px'
      }
    },
    inactive: {
      color: '#bbbbbb',
      fontWeight: 'bold',
      [breakpoints.down(500)]: {
        fontSize: '16px',
        padding: '0px',
        margin: '0px'
      }
    },
    chartContainer: {
      backgroundColor: COLORS.WHITE,
      padding: '10px 10px 40px 10px',
      position: 'relative',
      maxWidth: '2560px',
      width: '100%',
      [breakpoints.down(500)]: {
        padding: '0px 0 50px 0px',
      }
    },
    chartGrid: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }
  };
});

export default styles;
